var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("span", {
    staticClass: "flag",
    class: _vm.getLocation(),
    attrs: { title: _vm.getLocation() },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }